import { TtsLocale } from '../../models/Base';

import restClient, { RestRequestOptions, RestResponse } from '.';

interface TranslationData {
  translations: { input: string; output: string }[];
  to: TtsLocale;
  from: TtsLocale;
}

export const translateLanguage = (
  body: { inputs: string[]; from: TtsLocale; to: TtsLocale; isFree?: boolean },
  options?: RestRequestOptions,
): Promise<RestResponse<TranslationData>> => {
  return restClient.post(`/languages/translations`, body, options);
};

interface TextDetectionDataJson {
  description: string;
  locale: string;
  boundingPoly: { verticles: { x: number; y: number }[] };
}

interface TextDetectionData {
  detections: TextDetectionDataJson[][];
  price: { token: number };
}

export const textDetectLanguage = (
  body: { images: string[] },
  options?: RestRequestOptions,
): Promise<RestResponse<TextDetectionData>> => {
  return restClient.post(`/languages/text-detections`, body, options);
};
